import * as types from '../mutation-types'
import userService from '../../services/users'

const state = {
    loading: false,
    errors: null,
    guardians: [],
    gwards: []
}

const actions = {
    getAll({ commit }) {
        commit(types.GUARDIAN_LOADING, true)
        userService.getAll({ utype: "grd" }).then(
            response => {
               // console.log("responsoooooo", response)
                commit(types.LOAD_GUARDIANS, response.data)
                commit(types.GUARDIAN_FAILURE, null)
                commit(types.GUARDIAN_LOADING, false)
            },
            error => {
                commit(types.GUARDIAN_FAILURE, error)
                commit(types.GUARDIAN_LOADING, false)
            }
        )
    },
    myWards({ commit }) {
        commit(types.GUARDIAN_LOADING, true)
        userService.getAll({ utype: "gwd" }).then(
            response => {

                commit(types.MY_WARDS, response.data)
                commit(types.GUARDIAN_FAILURE, null)
                commit(types.GUARDIAN_LOADING, false)
            },
            error => {
                commit(types.GUARDIAN_FAILURE, error)
                commit(types.GUARDIAN_LOADING, false)
            }
        )
    },
    add({ commit }, data) {
        commit(types.GUARDIAN_LOADING, true)
        commit(types.GUARDIAN_FAILURE, null)
        data.roles = ['guardian']
        userService.add(data).then(
            response => {

                data.id = response.data.id
                commit(types.ADD_GUARDIAN, data)
                commit(types.GUARDIAN_LOADING, false)

            },
            error => {
              //console.log("errrr",error)
                commit(types.GUARDIAN_FAILURE, error)
                commit(types.GUARDIAN_LOADING, false)
            }
        )
    },
    update({ commit }, data) {
        commit(types.GUARDIAN_LOADING, true)
        commit(types.GUARDIAN_FAILURE, null)
        data.guardian.roles = ["guardian"]
        userService.update(data.guardian)
            .then(
                response => {
                    commit(types.UPDATE_GUARDIAN, data)
                    commit(types.GUARDIAN_LOADING, false)
                },
                error => {
                    commit(types.GUARDIAN_FAILURE, error)
                    commit(types.GUARDIAN_LOADING, false)
                }
            )


    },
    delete({ commit }, data) {
        commit(types.GUARDIAN_LOADING, true)
        commit(types.GUARDIAN_FAILURE, null)
        userService.delete(data.guardian.id)
            .then(
                response => {

                    commit(types.DELETE_GUARDIAN, data)
                    commit(types.GUARDIAN_LOADING, false)
                },
                error => {
                    commit(types.GUARDIAN_FAILURE, error)
                    commit(types.GUARDIAN_LOADING, false)
                }
            )
    }
}

const mutations = {
    [types.ADD_GUARDIAN](state, payload) {
        state.guardians.unshift(payload);
    },
    [types.LOAD_GUARDIANS](state, payload) {
        state.guardians = payload
    },
    [types.MY_WARDS](state, payload) {
        state.gwards = payload
    },
    [types.UPDATE_GUARDIAN](state, payload) {
        Object.assign(state.guardians[payload.index], payload.guardian);
    },
    [types.DELETE_GUARDIAN](state, payload) {
        state.guardians.splice(payload.index, 1)
    },
    [types.GUARDIAN_FAILURE](state, payload) {
        state.errors = payload
    },

    [types.GUARDIAN_LOADING](state, payload) {
        state.loading = payload
    },
}


const getters = {
    GUARDIANS: state => {
        return state.guardians
    },

    GUARDIAN_WARDS: state => {
        return state.gwards
    },

    GUARDIAN_ERROR: state => {
        return state.errors
    },

    GUARDIAN_LOADING: state => {
        return state.loading
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/guardians.js